// extracted by mini-css-extract-plugin
export var currencyInput = "_lw-1";
export var currencySymbol = "_lw-0";